import {
  actions,
  getAllContentEntityTypesAsync,
  getContentEntityTypeByNameAsync,
  getContentEntityTypeLookupsAsync,
  getContentEntityTypeByNameForModalAsync,
  getContentEntityTypeNavigationsAsync,
  getSelectSortFactorsAsync,
  createContentEntityMultilingualAsync,
  editContentEntityMultilingualAsync,
  getContentEntityTypeByIdMultilingualAsync,
  getContentEntityTypesDatatableAsync,
} from './slices';

export const ContentEntityTypeActions = {
  ...actions,
  getAllContentEntityTypesAsync,
  getContentEntityTypeByNameAsync,
  getContentEntityTypeLookupsAsync,
  getContentEntityTypeByNameForModalAsync,
  getContentEntityTypeNavigationsAsync,
  getSelectSortFactorsAsync,
  createContentEntityMultilingualAsync,
  editContentEntityMultilingualAsync,
  getContentEntityTypeByIdMultilingualAsync,
  getContentEntityTypesDatatableAsync,
};

export * from './thunkHandlers';

export * from './types';
